module.exports = __webpack_public_path__ + "img/g4.2e03c1dd.png";